import { COUNTRY_CODE } from '@cemex-core/cmx-api';
import { mx } from './mx/mx';
import { us } from './us/us';
import { uk } from './uk/uk';
import { il } from './il/il';
import { fr } from './fr/fr';
import { co } from './co/co';

export const config = {
  [COUNTRY_CODE.MEXICO]: mx,
  [COUNTRY_CODE.USA]: us,
  [COUNTRY_CODE.UNITED_KINGDOM]: uk,
  [COUNTRY_CODE.ISRAEL]: il,
  [COUNTRY_CODE.FRANCE]: fr,
  [COUNTRY_CODE.COLOMBIA]: co,
};
